const work1 = {
  workMeta: {
    workName: "SGGS Placements",
    link: "sggsplacements",
  },
  title: "Placement Website for SGGS Nanded",
  org: "SGGSIE&T, Nanded",
  year: 2022,
  stack: "React, Node.JS",
  desc: "The official website of the Training & Placements Cell of SGGS Institute of Engineering & Technology, Nanded, India. The placements cell oversees handling of company drives in the institute, as well as attracting recruiters and facilitating exams and interviews. Some of the tasks of the Cell included contacting and responding to recruiter HRs, supervising exams, organizing workshops and events, and more.",
  task: "This website was developed to be one of the main sources of placement information for the entire institute. The most important task that the website was to perform was to keep visitors up-to-date on placements and recruitments that recently took place. It also had to show the many upcoming and past events/workshops that the Cell would conduct. It also had to have pages containing contact details for the supervisors and members of the Cell. Lastly, there was to be an Administrator Console, where the administrator could quickly update placement details and add new upcoming events.",
  work: "The first task I performed was to convert the original barebones single-page website into a fully-fledged React frontend with dedicated pages. Soon after, I added a Node.js backend with a MongoDB database to handle CRUD tasks. Along with that came the Admin Console. Lastly, I handles maintenance and regular updates until the end of the term.",
  effect:
    "The website has become a core part of the Training & Placement Cell, and is still maintained by the current team.",
  hplink: "https://sggsplacements.in",
  cover: "sggstnp/cover.jpg",
  main: "sggstnp/placements-page.png",
  desktop: "sggstnp/home-desktop.png",
  laptop: "sggstnp/home-laptop.png",
  mobile: "sggstnp/home-mobile.png",
};

const work2 = {
  workMeta: {
    workName: "INSD Nanded",
    link: "insdnanded",
  },
  title: "Organizational website for INSD Nanded",
  org: "INSD Nanded",
  year: 2023,
  stack: "React, EmailJS",
  desc: "The official website for the Nanded branch of the Internation School of Design. The school offers Diploma, Bachelor's, Master's and Certification courses in multiple disciplines including Fashion Design, Textile Design, Interior Design and more.",
  task: "This website provides a portal for getting in-depth information about the courses, their syllabi, number of semesters and other similar details. It also provides an overview of the institute's facilities, events, activities and awards. Visitors are notified of ongoing admissions and are provided a way to directly contact the institute for enquiries.",
  work: "This was a freelance undertaking along with 2 of my classmates on behalf of the current Director at INSD Nanded. We distributed the tasks of designing and developing the website among us and built the website to match the employer's tastes. We also handled deployment and maintenance for the website.",
  effect:
    "The website garners a number of visitors every month, especially during admission season. It substantially improves the ease of access to details for the interested parties.",
  hplink: "https://insdnanded.com",
  cover: "insdnanded/cover.jpg",
  main: "insdnanded/fashiondesign-course-page.png",
  desktop: "insdnanded/home-desktop.png",
  laptop: "insdnanded/home-laptop.png",
  mobile: "insdnanded/home-mobile.png",
};

export const workList = [work1, work2];
